/* Lamberty Munich · Lieferland-Logik (gemeinsam) + Slide-in als Bestaetigung
   Owner 08.10.2026 Runde 6 (nach Hermes-Muster):
   - Slide-in = nur "Artikel wurde in den Warenkorb gelegt", der Artikel, "Warenkorb ansehen",
     "Weiter einkaufen". Keine Lieferweiche, kein Checkout im Slide-in.
   - Lieferweiche, Versandkosten und Geschenk sitzen auf der Warenkorbseite (assets/lm-cart.js).
   - Land: IP < Website (Laenderwahl im Kopf) < Warenkorb (Auswahl auf der Warenkorbseite).
   - DIRECT = localization.available_countries zur Renderzeit (data-lm-direct), keine feste
     Direktlaenderliste (R-23). W&B-Laender = Seite Lieferung & Rueckgabe.
   - Geschlossene Laender gehen nie an /localization (R-24).
   Stellt window.LMDest fuer die Warenkorbseite bereit.
   v27 20.10.2026: FR-Zweig (NAME.fr, TO_FR, MAXED.fr; Sprache aus document.documentElement.lang de/fr/en).
*/
(function () {
  if (window.LMDest) return;

  var KEY = 'lmCartDest';
  var WEB_KEY = 'lmWebDest';
  var GEO_KEY = 'lmGeoCountry';
  var WB = 'GB AL AD BH BD BA CN GI GG IM JE QA KW MO MY MX ME MK OM KR MD SM SA RS ZA TW TH TR VA VN'.split(' ');
  var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE MC'.split(' ');
  var ALL = 'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW XK'.split(' ');

  var NAME = {
    de: { HK: 'Hongkong', MO: 'Macau', CD: 'Demokratische Republik Kongo', CG: 'Republik Kongo', PS: 'Palästinensische Gebiete' },
    en: { HK: 'Hong Kong', MO: 'Macao', CD: 'Democratic Republic of the Congo', CG: 'Republic of the Congo', MM: 'Myanmar', PS: 'Palestinian Territories', US: 'USA' },
    fr: { AD: 'Andorre', AE: 'Émirats arabes unis', AF: 'Afghanistan', AG: 'Antigua-et-Barbuda', AI: 'Anguilla', AL: 'Albanie', AM: 'Arménie', AO: 'Angola', AR: 'Argentine', AS: 'Samoa américaines', AT: 'Autriche', AU: 'Australie', AW: 'Aruba', AX: 'Îles Åland', AZ: 'Azerbaïdjan', BA: 'Bosnie-Herzégovine', BB: 'Barbade', BD: 'Bangladesh', BE: 'Belgique', BF: 'Burkina Faso', BG: 'Bulgarie', BH: 'Bahreïn', BI: 'Burundi', BJ: 'Bénin', BL: 'Saint-Barthélemy', BM: 'Bermudes', BN: 'Brunei', BO: 'Bolivie', BQ: 'Pays-Bas caribéens', BR: 'Brésil', BS: 'Bahamas', BT: 'Bhoutan', BW: 'Botswana', BY: 'Biélorussie', BZ: 'Belize', CA: 'Canada', CC: 'Îles Cocos', CD: 'République démocratique du Congo', CF: 'République centrafricaine', CG: 'République du Congo', CH: 'Suisse', CI: 'Côte d’Ivoire', CK: 'Îles Cook', CL: 'Chili', CM: 'Cameroun', CN: 'Chine', CO: 'Colombie', CR: 'Costa Rica', CU: 'Cuba', CV: 'Cap-Vert', CW: 'Curaçao', CX: 'Île Christmas', CY: 'Chypre', CZ: 'Tchéquie', DE: 'Allemagne', DJ: 'Djibouti', DK: 'Danemark', DM: 'Dominique', DO: 'République dominicaine', DZ: 'Algérie', EC: 'Équateur', EE: 'Estonie', EG: 'Égypte', EH: 'Sahara occidental', ER: 'Érythrée', ES: 'Espagne', ET: 'Éthiopie', FI: 'Finlande', FJ: 'Fidji', FK: 'Îles Malouines', FM: 'Micronésie', FO: 'Îles Féroé', FR: 'France', GA: 'Gabon', GB: 'Royaume-Uni', GD: 'Grenade', GE: 'Géorgie', GF: 'Guyane française', GG: 'Guernesey', GH: 'Ghana', GI: 'Gibraltar', GL: 'Groenland', GM: 'Gambie', GN: 'Guinée', GP: 'Guadeloupe', GQ: 'Guinée équatoriale', GR: 'Grèce', GT: 'Guatemala', GU: 'Guam', GW: 'Guinée-Bissau', GY: 'Guyana', HK: 'Hong Kong', HN: 'Honduras', HR: 'Croatie', HT: 'Haïti', HU: 'Hongrie', ID: 'Indonésie', IE: 'Irlande', IL: 'Israël', IM: 'Île de Man', IN: 'Inde', IQ: 'Irak', IR: 'Iran', IS: 'Islande', IT: 'Italie', JE: 'Jersey', JM: 'Jamaïque', JO: 'Jordanie', JP: 'Japon', KE: 'Kenya', KG: 'Kirghizstan', KH: 'Cambodge', KI: 'Kiribati', KM: 'Comores', KN: 'Saint-Christophe-et-Niévès', KP: 'Corée du Nord', KR: 'Corée du Sud', KW: 'Koweït', KY: 'Îles Caïmans', KZ: 'Kazakhstan', LA: 'Laos', LB: 'Liban', LC: 'Sainte-Lucie', LI: 'Liechtenstein', LK: 'Sri Lanka', LR: 'Liberia', LS: 'Lesotho', LT: 'Lituanie', LU: 'Luxembourg', LV: 'Lettonie', LY: 'Libye', MA: 'Maroc', MC: 'Monaco', MD: 'Moldavie', ME: 'Monténégro', MF: 'Saint-Martin', MG: 'Madagascar', MH: 'Îles Marshall', MK: 'Macédoine du Nord', ML: 'Mali', MM: 'Myanmar', MN: 'Mongolie', MO: 'Macao', MP: 'Îles Mariannes du Nord', MQ: 'Martinique', MR: 'Mauritanie', MS: 'Montserrat', MT: 'Malte', MU: 'Maurice', MV: 'Maldives', MW: 'Malawi', MX: 'Mexique', MY: 'Malaisie', MZ: 'Mozambique', NA: 'Namibie', NC: 'Nouvelle-Calédonie', NE: 'Niger', NF: 'Île Norfolk', NG: 'Nigeria', NI: 'Nicaragua', NL: 'Pays-Bas', NO: 'Norvège', NP: 'Népal', NR: 'Nauru', NU: 'Niue', NZ: 'Nouvelle-Zélande', OM: 'Oman', PA: 'Panama', PE: 'Pérou', PF: 'Polynésie française', PG: 'Papouasie-Nouvelle-Guinée', PH: 'Philippines', PK: 'Pakistan', PL: 'Pologne', PM: 'Saint-Pierre-et-Miquelon', PN: 'Îles Pitcairn', PR: 'Porto Rico', PS: 'Territoires palestiniens', PT: 'Portugal', PW: 'Palaos', PY: 'Paraguay', QA: 'Qatar', RE: 'La Réunion', RO: 'Roumanie', RS: 'Serbie', RU: 'Russie', RW: 'Rwanda', SA: 'Arabie saoudite', SB: 'Îles Salomon', SC: 'Seychelles', SD: 'Soudan', SE: 'Suède', SG: 'Singapour', SH: 'Sainte-Hélène', SI: 'Slovénie', SJ: 'Svalbard et Jan Mayen', SK: 'Slovaquie', SL: 'Sierra Leone', SM: 'Saint-Marin', SN: 'Sénégal', SO: 'Somalie', SR: 'Suriname', SS: 'Soudan du Sud', ST: 'Sao Tomé-et-Principe', SV: 'Salvador', SX: 'Saint-Martin (partie néerlandaise)', SY: 'Syrie', SZ: 'Eswatini', TC: 'Îles Turques-et-Caïques', TD: 'Tchad', TG: 'Togo', TH: 'Thaïlande', TJ: 'Tadjikistan', TK: 'Tokelau', TL: 'Timor-Leste', TM: 'Turkménistan', TN: 'Tunisie', TO: 'Tonga', TR: 'Turquie', TT: 'Trinité-et-Tobago', TV: 'Tuvalu', TW: 'Taïwan', TZ: 'Tanzanie', UA: 'Ukraine', UG: 'Ouganda', US: 'États-Unis', UY: 'Uruguay', UZ: 'Ouzbékistan', VA: 'Cité du Vatican', VC: 'Saint-Vincent-et-les Grenadines', VE: 'Venezuela', VG: 'Îles Vierges britanniques', VI: 'Îles Vierges américaines', VN: 'Viêt Nam', VU: 'Vanuatu', WF: 'Wallis-et-Futuna', WS: 'Samoa', XK: 'Kosovo', YE: 'Yémen', YT: 'Mayotte', ZA: 'Afrique du Sud', ZM: 'Zambie', ZW: 'Zimbabwe' }
  };
  var TO_DE = {
    CH: 'in die Schweiz', TR: 'in die Türkei', SK: 'in die Slowakei', UA: 'in die Ukraine', MN: 'in die Mongolei',
    DO: 'in die Dominikanische Republik', CF: 'in die Zentralafrikanische Republik', CD: 'in die Demokratische Republik Kongo',
    CG: 'in die Republik Kongo', MD: 'in die Republik Moldau', EH: 'in die Westsahara', PS: 'in die Palästinensischen Gebiete',
    US: 'in die USA', NL: 'in die Niederlande', AE: 'in die Vereinigten Arabischen Emirate', GB: 'ins Vereinigte Königreich',
    IR: 'in den Iran', IQ: 'in den Irak', LB: 'in den Libanon', SD: 'in den Sudan', SS: 'in den Südsudan', YE: 'in den Jemen',
    TD: 'in den Tschad', NE: 'in den Niger', VA: 'in die Vatikanstadt',
    PH: 'auf die Philippinen', BS: 'auf die Bahamas', MV: 'auf die Malediven', SC: 'auf die Seychellen', KM: 'auf die Komoren',
    SB: 'auf die Salomonen', MH: 'auf die Marshallinseln', FO: 'auf die Färöer', KY: 'auf die Kaimaninseln',
    VG: 'auf die Britischen Jungferninseln', VI: 'auf die Amerikanischen Jungferninseln', TC: 'auf die Turks- und Caicosinseln',
    FK: 'auf die Falklandinseln', CK: 'auf die Cookinseln', PN: 'auf die Pitcairninseln', AX: 'auf die Ålandinseln',
    MP: 'auf die Nördlichen Marianen', CC: 'auf die Kokosinseln', CX: 'auf die Weihnachtsinsel', NF: 'auf die Norfolkinsel',
    IM: 'auf die Isle of Man'
  };
  /* v27 20.10.2026: FR-Laendernamen und -phrasen fuer alle Codes in ALL, Uebersetzung ChatGPT (FR_OFFEN_2026-10-20_CHATGPT.md Teil D), geprueft Claude */
  var TO_FR = {
    AD: 'en Andorre', AE: 'aux Émirats arabes unis', AF: 'en Afghanistan', AG: 'à Antigua-et-Barbuda', AI: 'à Anguilla',
    AL: 'en Albanie', AM: 'en Arménie', AO: 'en Angola', AR: 'en Argentine', AS: 'aux Samoa américaines',
    AT: 'en Autriche', AU: 'en Australie', AW: 'à Aruba', AX: 'aux îles Åland', AZ: 'en Azerbaïdjan',
    BA: 'en Bosnie-Herzégovine', BB: 'à la Barbade', BD: 'au Bangladesh', BE: 'en Belgique', BF: 'au Burkina Faso',
    BG: 'en Bulgarie', BH: 'au Bahreïn', BI: 'au Burundi', BJ: 'au Bénin', BL: 'à Saint-Barthélemy',
    BM: 'aux Bermudes', BN: 'au Brunei', BO: 'en Bolivie', BQ: 'aux Pays-Bas caribéens', BR: 'au Brésil',
    BS: 'aux Bahamas', BT: 'au Bhoutan', BW: 'au Botswana', BY: 'en Biélorussie', BZ: 'au Belize',
    CA: 'au Canada', CC: 'aux îles Cocos', CD: 'en République démocratique du Congo', CF: 'en République centrafricaine', CG: 'en République du Congo',
    CH: 'en Suisse', CI: 'en Côte d’Ivoire', CK: 'aux îles Cook', CL: 'au Chili', CM: 'au Cameroun',
    CN: 'en Chine', CO: 'en Colombie', CR: 'au Costa Rica', CU: 'à Cuba', CV: 'au Cap-Vert',
    CW: 'à Curaçao', CX: 'sur l’île Christmas', CY: 'à Chypre', CZ: 'en Tchéquie', DE: 'en Allemagne',
    DJ: 'à Djibouti', DK: 'au Danemark', DM: 'en Dominique', DO: 'en République dominicaine', DZ: 'en Algérie',
    EC: 'en Équateur', EE: 'en Estonie', EG: 'en Égypte', EH: 'au Sahara occidental', ER: 'en Érythrée',
    ES: 'en Espagne', ET: 'en Éthiopie', FI: 'en Finlande', FJ: 'aux Fidji', FK: 'aux îles Malouines',
    FM: 'en Micronésie', FO: 'aux îles Féroé', FR: 'en France', GA: 'au Gabon', GB: 'au Royaume-Uni',
    GD: 'à la Grenade', GE: 'en Géorgie', GF: 'en Guyane française', GG: 'à Guernesey', GH: 'au Ghana',
    GI: 'à Gibraltar', GL: 'au Groenland', GM: 'en Gambie', GN: 'en Guinée', GP: 'en Guadeloupe',
    GQ: 'en Guinée équatoriale', GR: 'en Grèce', GT: 'au Guatemala', GU: 'à Guam', GW: 'en Guinée-Bissau',
    GY: 'au Guyana', HK: 'à Hong Kong', HN: 'au Honduras', HR: 'en Croatie', HT: 'en Haïti',
    HU: 'en Hongrie', ID: 'en Indonésie', IE: 'en Irlande', IL: 'en Israël', IM: 'sur l’île de Man',
    IN: 'en Inde', IQ: 'en Irak', IR: 'en Iran', IS: 'en Islande', IT: 'en Italie',
    JE: 'à Jersey', JM: 'en Jamaïque', JO: 'en Jordanie', JP: 'au Japon', KE: 'au Kenya',
    KG: 'au Kirghizstan', KH: 'au Cambodge', KI: 'aux Kiribati', KM: 'aux Comores', KN: 'à Saint-Christophe-et-Niévès',
    KP: 'en Corée du Nord', KR: 'en Corée du Sud', KW: 'au Koweït', KY: 'aux îles Caïmans', KZ: 'au Kazakhstan',
    LA: 'au Laos', LB: 'au Liban', LC: 'à Sainte-Lucie', LI: 'au Liechtenstein', LK: 'au Sri Lanka',
    LR: 'au Liberia', LS: 'au Lesotho', LT: 'en Lituanie', LU: 'au Luxembourg', LV: 'en Lettonie',
    LY: 'en Libye', MA: 'au Maroc', MC: 'à Monaco', MD: 'en Moldavie', ME: 'au Monténégro',
    MF: 'à Saint-Martin', MG: 'à Madagascar', MH: 'aux îles Marshall', MK: 'en Macédoine du Nord', ML: 'au Mali',
    MM: 'au Myanmar', MN: 'en Mongolie', MO: 'à Macao', MP: 'aux îles Mariannes du Nord', MQ: 'en Martinique',
    MR: 'en Mauritanie', MS: 'à Montserrat', MT: 'à Malte', MU: 'à Maurice', MV: 'aux Maldives',
    MW: 'au Malawi', MX: 'au Mexique', MY: 'en Malaisie', MZ: 'au Mozambique', NA: 'en Namibie',
    NC: 'en Nouvelle-Calédonie', NE: 'au Niger', NF: 'sur l’île Norfolk', NG: 'au Nigeria', NI: 'au Nicaragua',
    NL: 'aux Pays-Bas', NO: 'en Norvège', NP: 'au Népal', NR: 'à Nauru', NU: 'à Niue',
    NZ: 'en Nouvelle-Zélande', OM: 'à Oman', PA: 'au Panama', PE: 'au Pérou', PF: 'en Polynésie française',
    PG: 'en Papouasie-Nouvelle-Guinée', PH: 'aux Philippines', PK: 'au Pakistan', PL: 'en Pologne', PM: 'à Saint-Pierre-et-Miquelon',
    PN: 'aux îles Pitcairn', PR: 'à Porto Rico', PS: 'dans les Territoires palestiniens', PT: 'au Portugal', PW: 'aux Palaos',
    PY: 'au Paraguay', QA: 'au Qatar', RE: 'à La Réunion', RO: 'en Roumanie', RS: 'en Serbie',
    RU: 'en Russie', RW: 'au Rwanda', SA: 'en Arabie saoudite', SB: 'aux îles Salomon', SC: 'aux Seychelles',
    SD: 'au Soudan', SE: 'en Suède', SG: 'à Singapour', SH: 'à Sainte-Hélène', SI: 'en Slovénie',
    SJ: 'au Svalbard et à Jan Mayen', SK: 'en Slovaquie', SL: 'en Sierra Leone', SM: 'à Saint-Marin', SN: 'au Sénégal',
    SO: 'en Somalie', SR: 'au Suriname', SS: 'en Soudan du Sud', ST: 'à Sao Tomé-et-Principe', SV: 'au Salvador',
    SX: 'à Saint-Martin (partie néerlandaise)', SY: 'en Syrie', SZ: 'en Eswatini', TC: 'aux îles Turques-et-Caïques', TD: 'au Tchad',
    TG: 'au Togo', TH: 'en Thaïlande', TJ: 'au Tadjikistan', TK: 'à Tokelau', TL: 'au Timor-Leste',
    TM: 'au Turkménistan', TN: 'en Tunisie', TO: 'aux Tonga', TR: 'en Turquie', TT: 'à Trinité-et-Tobago',
    TV: 'aux Tuvalu', TW: 'à Taïwan', TZ: 'en Tanzanie', UA: 'en Ukraine', UG: 'en Ouganda',
    US: 'aux États-Unis', UY: 'en Uruguay', UZ: 'en Ouzbékistan', VA: 'dans la Cité du Vatican', VC: 'à Saint-Vincent-et-les Grenadines',
    VE: 'au Venezuela', VG: 'aux îles Vierges britanniques', VI: 'aux îles Vierges américaines', VN: 'au Viêt Nam', VU: 'au Vanuatu',
    WF: 'à Wallis-et-Futuna', WS: 'aux Samoa', XK: 'au Kosovo', YE: 'au Yémen', YT: 'à Mayotte',
    ZA: 'en Afrique du Sud', ZM: 'en Zambie', ZW: 'au Zimbabwe'
  };
  var THE_EN = 'US GB NL AE PH BS MV KM SB MH FO KY VG VI TC FK CK PN AX MP CC DO CF CD CG GM PS SC'.split(' ');

  function lsGet(k) { try { return window.localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function cfg() { return document.querySelector('[data-lm-direct]'); }
  function directList() { var c = cfg(); return c ? (c.getAttribute('data-lm-direct') || '').split(',').filter(Boolean) : []; }

  function countryName(code, l) {
    var n = NAME[l] && NAME[l][code];
    if (n) return n;
    try { return new Intl.DisplayNames([l], { type: 'region' }).of(code) || code; } catch (e) { return code; }
  }
  function toPhrase(code, l) {
    if (l === 'de') return TO_DE[code] || 'nach ' + countryName(code, l);
    if (l === 'fr') return TO_FR[code] || 'vers ' + countryName(code, l);
    return 'to ' + (THE_EN.indexOf(code) > -1 ? 'the ' : '') + countryName(code, l);
  }
  function stateOf(code) {
    if (!code) return 'GEO';
    if (directList().indexOf(code) > -1) return 'A';
    if (WB.indexOf(code) > -1) return 'B';
    return 'C';
  }

  var geoPromise = null;
  function detect() {
    var cached = ssGet(GEO_KEY);
    if (cached) return Promise.resolve(cached === '-' ? '' : cached);
    if (!geoPromise) {
      geoPromise = fetch(root() + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          c = c && ALL.indexOf(c) > -1 ? c : '';
          ssSet(GEO_KEY, c || '-');
          return c;
        })
        .catch(function () { return ''; });
    }
    return geoPromise;
  }
  /* Rangfolge: Warenkorb vor Website vor IP */
  function resolveCountry() {
    var chosen = lsGet(KEY) || lsGet(WEB_KEY);
    return chosen ? Promise.resolve(chosen) : detect();
  }
  function setCartChoice(code) { if (code) lsSet(KEY, code); }

  /* Direktland -> Shopify-Land nachziehen (Warenkorb, Preise, Checkout). Nie fuer geschlossene Laender. */
  function updateLocalization(code) {
    var el = cfg();
    var ctx = el ? el.getAttribute('data-lm-ctx') : '';
    if (!el || !code || code === ctx || stateOf(code) !== 'A') return Promise.resolve(false);
    var form = document.querySelector('form.lm-cd__loc');
    if (!form) return Promise.resolve(false);
    var fd = new FormData(form);
    fd.set('country_code', code);
    fd.set('return_to', window.location.pathname);
    return fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        /* Review 10.10.2026: nur bei erfolgreicher Antwort als gewechselt werten */
        if (!r || !r.ok) return false;
        document.querySelectorAll('[data-lm-ctx]').forEach(function (x) { x.setAttribute('data-lm-ctx', code); });
        return true;
      })
      .catch(function () { return false; });
  }

  window.LMDest = {
    ALL: ALL, WB: WB, EU: EU,
    countryName: countryName, toPhrase: toPhrase, stateOf: stateOf, detect: detect,
    resolveCountry: resolveCountry, setCartChoice: setCartChoice, updateLocalization: updateLocalization,
    root: root
  };

  detect();

  /* Laenderwahl im Kopf (Shopify-Formular) = Wahl auf der Website */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/localization"]') || f.classList.contains('lm-cd__loc')) return;
    var cc = f.querySelector('[name="country_code"]');
    if (cc && cc.value) lsSet(WEB_KEY, cc.value);
  }, true);

  /* ---------- Slide-in: nur Bestaetigung des eben hinzugefuegten Artikels ---------- */
  function setFocus(id) {
    var st = document.getElementById('lm-cd-focus');
    if (!st) { st = document.createElement('style'); st.id = 'lm-cd-focus'; document.head.appendChild(st); }
    var safe = String(id || '').replace(/[^0-9]/g, '');
    st.textContent = safe ? 'cart-drawer .cart-item:not([data-lm-variant="' + safe + '"]){display:none !important}' : '';
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var idInput = f.querySelector('[name="id"]');
    if (idInput) setFocus(idInput.value);
  }, true);

  /* Runde 8 (Owner): Shopify-Hinweis "maximale Menge ... in deinem Warenkorb" auf der
     Produktseite durch den Owner-Wortlaut ersetzen (Sie-Form). Andere Fehler bleiben unveraendert. */
  var MAXED = {
    de: 'Sie haben bereits das letzte verfügbare Tuch in den Warenkorb gelegt.',
    en: 'You have already added the last available scarf to your basket.',
    fr: 'Vous avez déjà ajouté à votre panier le dernier exemplaire disponible.'
  };
  /* v27: FR-Muster der Shopify-Meldung ergaenzt (Wortlaut der FR-Shopify-Meldung im Test pruefen) */
  var MAX_RE = /maximale Menge|maximum quantity|bereits in deinem Warenkorb|already in your cart|can.t add more|kannst .* nicht mehr|quantité maximale|déjà dans votre panier|ne pouvez pas ajouter plus/i;
  function watchError(f) {
    var host = f.closest('product-form') || f.parentElement;
    if (!host || host.__lmMaxWatch) return;
    host.__lmMaxWatch = true;
    var lg = (document.documentElement.lang || '').slice(0, 2);
    var l = lg === 'de' ? 'de' : (lg === 'fr' ? 'fr' : 'en');
    var fix = function () {
      host.querySelectorAll('.product-form__error-message').forEach(function (el) {
        var tx = el.textContent || '';
        if (tx && tx !== MAXED[l] && MAX_RE.test(tx)) el.textContent = MAXED[l];
      });
    };
    new MutationObserver(fix).observe(host, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]')) watchError(f);
  }, true);

  /* Warenkorb-Symbol im Kopf -> Warenkorbseite statt Slide-in */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a) return;
    e.stopImmediatePropagation();
  }, true);

  /* "Weiter einkaufen" im Slide-in schliesst es */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lm-close-drawer]');
    if (!b) return;
    e.preventDefault();
    var dr = document.querySelector('cart-drawer');
    if (dr && typeof dr.close === 'function') dr.close();
  });

  /* Checkout-Klick (Warenkorbseite): gewaehltes Direktland sicher an Shopify uebergeben */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn) return;
    var code = lsGet(KEY) || lsGet(WEB_KEY);
    var el = cfg();
    if (!el || !code || stateOf(code) !== 'A' || code === el.getAttribute('data-lm-ctx')) return;
    var form = document.querySelector('form.lm-cd__loc');
    if (!form) return;
    e.preventDefault();
    form.querySelector('[name="country_code"]').value = code;
    var rt = form.querySelector('[name="return_to"]');
    if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
    rt.value = '/checkout';
    form.submit();
  }, true);

  /* Owner 19.10.2026 (PM C3): Nach Browser-Zurueck zeigt der Seiten-Zwischenspeicher (bfcache) die alte
     Warenkorb-Zahl. Bei pageshow mit persisted das Symbol frisch von Shopify holen; auf der Warenkorbseite
     die Seite neu laden, damit Artikel und Summen stimmen. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    fetch(root() + '?sections=cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var html = d && d['cart-icon-bubble'];
        var dst = document.getElementById('cart-icon-bubble');
        if (!html || !dst) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (src) dst.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  });
})();
